import { render, staticRenderFns } from "./operateConfig.vue?vue&type=template&id=dd4d4864&scoped=true&"
import script from "./operateConfig.vue?vue&type=script&lang=js&"
export * from "./operateConfig.vue?vue&type=script&lang=js&"
import style0 from "./operateConfig.vue?vue&type=style&index=0&id=dd4d4864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4d4864",
  null
  
)

export default component.exports